import { request } from '../client'
import type {
  ArenaCreateRequest,
  ArenaJoinRequest,
  ArenaListResponse,
  ArenaRoom,
  ArenaRoomDetailsResponse,
} from '@/types/arena'

export async function getArenaRooms() {
  return request<ArenaListResponse>({
    method: 'GET',
    url: '/v1/arena',
  })
}

export async function getArenaRoom(shortId: string) {
  return request<ArenaRoomDetailsResponse>({
    method: 'GET',
    url: `/v1/arena/${shortId}`,
  })
}

export async function createArenaRoom(payload: ArenaCreateRequest) {
  return request<ArenaRoom>({
    method: 'POST',
    url: '/v1/arena/create',
    data: payload,
  })
}

export async function joinArenaRoom(shortId: string, payload: ArenaJoinRequest) {
  return request({
    method: 'POST',
    url: `/v1/arena/${shortId}/join`,
    data: payload,
  })
}

export async function readyArenaRoom(shortId: string) {
  return request({
    method: 'POST',
    url: `/v1/arena/${shortId}/ready`,
  })
}
